module.exports = __webpack_public_path__ + "img/BMO_DEMO.bc683bcd.gif";